import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalHeaderService } from '../global-header.service';
import { ContextService } from '../context.service';
import { AccommodationOverview } from '../accommodation-overview';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-accommodation-overview',
  templateUrl: './accommodation-overview.component.html',
  styleUrls: ['./accommodation-overview.component.less']
})
export class AccommodationOverviewComponent implements OnInit, OnDestroy {
  
  private subscriptions = new Subscription();

  public model : AccommodationOverview

  constructor(
    private route: ActivatedRoute,
    private contextService: ContextService,
    private headerService: GlobalHeaderService ) {
  }

  ngOnInit() {
    this.model = new AccommodationOverview();

    var subscription = this.route.paramMap.subscribe(params => {
      var itemsSubscription = this.contextService.getAccommodations().subscribe(data => {
        this.model.items = data;
        this.headerService.setHead(this.model);
      });

      this.subscriptions.add(itemsSubscription);
    });

    this.subscriptions.add(subscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
